import { DependencyList, useEffect, useState } from "react";

export function usePromise<T, E = any, A = any>(
  promise: (args?: A) => Promise<T>,
  deps: DependencyList = []
): [T | undefined, boolean, E | undefined, (args?: A) => Promise<T>] {
  const [data, setData] = useState<T>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<E>();

  useEffect(() => {
    setLoading(true);
    setError(undefined);

    let isCurrent = true;

    promise()
      .then((data) => {
        if (!isCurrent) return;

        setData(data);
        setError(undefined);
        setLoading(false);
      })
      .catch((error) => {
        if (!isCurrent) return;

        setData(undefined);
        setError(error);
        setLoading(false);
      });

    return () => {
      isCurrent = false;
    };
  }, deps);

  async function reload(args?: A) {
    setLoading(true);
    setError(undefined);

    try {
      const data = await promise(args);

      setData(data);
      setError(undefined);

      return data;
    } catch (error) {
      setData(undefined);
      setError(error as E);

      throw error;
    } finally {
      setLoading(false);
    }
  }

  return [data, loading, error, reload];
}
